import {
	FOREIGN_ROLE_NAMES,
	getRolesForUser,
	MAIN_PAGE,
	RoleEnum,
	SYSTEM_ROLE_NAMES,
	WORKER_ADMIN_PUBLIC_ADMIN_ROLE_NAMES,
	WORKER_MASTER_SUPER_ROLE_NAMES,
	WORKER_ROLE_NAMES,
} from '@/constant';
import { TDataMyPage } from '@/services';

import { includes } from 'ramda';

export const formatDataMyPage = (data: TDataMyPage) => {
	return {
		...data,
		isSystemRole: includes(data?.role, SYSTEM_ROLE_NAMES),
		isWorkerRole: includes(data?.role, WORKER_ROLE_NAMES),
		isWorkerMasterOrSuperRole: includes(
			data?.role,
			WORKER_MASTER_SUPER_ROLE_NAMES
		),
		isWorkerAdminOrPublicAdminRole: includes(
			data?.role,
			WORKER_ADMIN_PUBLIC_ADMIN_ROLE_NAMES
		),
		isWorkerMasterRole: data?.role === RoleEnum.MASTER_ADMIN,
		isWorkerSuperRole: data?.role === RoleEnum.SUPER_ADMIN,
		isWorkerAdminRole: data?.role === RoleEnum.ADMIN,
		isWorkerPublicAdminRole: data?.role === RoleEnum.PUBLIC_ADMIN,
		isForeignRole: includes(data?.role, FOREIGN_ROLE_NAMES),
		isForeignMasterRole: data?.role === RoleEnum.FOREIGN_MASTER_ADMIN,
		isForeignAdminRole: data?.role === RoleEnum.FOREIGN_ADMIN,
		toPath: MAIN_PAGE[data?.role],
		roleOptions: getRolesForUser(data?.role),
		registId: data?.id,
	};
};
